import toast from 'react-hot-toast';

export const notify = toast;